import { AccountService } from '../../services/api/account.service';
import { ConfigService } from '../../services/api/config.service';
import { Component, OnInit } from '@angular/core';
import { CONSTANTS } from '../../constants';
import { NotificationService } from '../../services/notification.service';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, Validators} from '@angular/forms';
import { AppService } from '../../services/api/app.service';
import { BrokerService } from '../../services/api/broker.service';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-profile',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {

  profile_form: UntypedFormGroup = new UntypedFormGroup({});
  config_form: UntypedFormGroup = new UntypedFormGroup({});
  dd_settings = {};
  account: any = {};
  config = {};
  contracts_status = "Not Loaded";
  feed_user_status = "Not Connected";
  admin: any;

  constructor(private accountService : AccountService, private appService : AppService,
    private brokerService: BrokerService, private configService : ConfigService, private dataService: DataService,
    private fb: UntypedFormBuilder, private notificationService: NotificationService) {
      this.profile_form = fb.group({
        email:['', [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]],
        phone: ['', [Validators.required, Validators.pattern("[0-9 ]{10}")]],
        subscriptionEndDate: ['']
      });
      this.config_form = fb.group({
        feed_token:['', [Validators.required]],
        feed_id: ['', [Validators.required]],
        feed_broker: ['', [Validators.required]]
      });
  }

  ngOnInit(): void {
    this.admin = sessionStorage.getItem(CONSTANTS.COOKIE.IS_ADMIN);
    if(this.admin == 'true'){
      this.getConfigDetails();
      this.getAppState();
    }
    this.getAccountDetails();
    this.dataService.pageLoaded({name: CONSTANTS.URI_PATH.SETTINGS});
  }

  get pf() {
    return this.profile_form.controls;
  }

  get cf() {
    return this.config_form.controls;
  }

  get pf_email() {
    return this.profile_form.controls['email'] as FormControl;
  }

  get pf_email_errors() {
    return (this.profile_form.controls['email'] as FormControl).errors as ValidationErrors;
  }

  get pf_phone() {
    return this.profile_form.controls['phone'] as FormControl;
  }

  get pf_phone_errors() {
    return (this.profile_form.controls['phone'] as FormControl).errors as ValidationErrors;
  }

  get cf_feed_id() {
    return this.config_form.controls['feed_id'] as FormControl;
  }

  get cf_feed_id_errors() {
    return (this.config_form.controls['feed_id'] as FormControl).errors as ValidationErrors;
  }

  get cf_feed_broker() {
    return this.config_form.controls['feed_broker'] as FormControl;
  }

  get cf_feed_broker_errors() {
    return (this.config_form.controls['feed_broker'] as FormControl).errors as ValidationErrors;
  }

  get cf_feed_token() {
    return this.config_form.controls['feed_token'] as FormControl;
  }

  get cf_feed_token_errors() {
    return (this.config_form.controls['feed_token'] as FormControl).errors as ValidationErrors;
  }

  getAccountDetails() {
    this.accountService.getAccountDetails().subscribe((response: any) => {
      if (response.response_code == 1000) {
        this.profile_form.patchValue({
          phone: response.account.user.phone,
          email: response.account.user.email,
          subscriptionEndDate: response.account.subscription_upto
        });
        this.account = response.account;
      }
    });
  }

  getConfigDetails() {
    let input = {
      keys: 'enc_token,zrdha_feed_id,preferred_broker'
    }
    this.configService.getAuthConfigs(input).subscribe((response: any) => {
      if (response.response_code == 1000) {
        this.config_form.patchValue({
          feed_token: response.cds.enc_token,
          feed_id: response.cds.zrdha_feed_id,
          feed_broker: response.cds.preferred_broker
        });
        this.config = response.cds;
      }
    });
  }

  getAppState() {
    this.appService.getAppState().subscribe((response: any) => {
      this.contracts_status = (response.cache_init == 1) ? 'Loaded' : 'Not Loaded'
      this.feed_user_status = (response.feed_user_status == 1) ? 'Connected' : 'Not Connected'
    });
  }

  submit(stype: any) {
    if (stype == 'profile') {
      let input = { 
        "account_id": this.account['_id'],
        "user": {
          "_id": this.account['user']['_id'], 
          "full_name": this.account['user']['full_name'], 
          "phone": this.profile_form.value.phone,
          "email": this.profile_form.value.email
        },
        "subscription_upto": this.account['subscription_upto']
      };
      if (this.profile_form.valid) {
        this.accountService.updateAccount(input).subscribe((response: any) => {
          if (response.response_code == 1000) {
            this.notificationService.showAlert(CONSTANTS.SUCCESS, "Profile Updated");
          }
        });
      }
    } else if (stype == 'config') {
      let key_map: any = {'enc_token': 'feed_token','zrdha_feed_id':'feed_id','preferred_broker':'feed_broker'}
      let cds = []
      for (let key in key_map) {
        cds.push({key:key,value:this.config_form.value[key_map[key]]})
      }
      if (this.config_form.valid) {
        this.configService.updateCDatas({ cds }).subscribe((response: any) => {
          if (response.response_code == 1000) {
            this.notificationService.showAlert(CONSTANTS.SUCCESS, "Config Updated");
          }
        });
      }
    }
  }

  loginFeedUser() {
    this.brokerService.contractAccountLogin({bname:'zerodha'}).subscribe((response: any) => {
      window.open(response.url);
    });
  }

  loadContracts() {
    this.appService.initApp({force:1}).subscribe((response: any) => {
      this.getAppState();
    });
  }
}
